export const PublicRoutes = {
  LOGIN: 'login',
};

export const PrivateRoutes = {
  DASHBOARD: 'dashboard',
	PRIVATE: 'private',

};
